export const PageHeader = ({ title, subtitle, children }) => (!title && !children ? null : (
  <div className="flex flex-col sm:flex-row sm:items-end gap-4">
    {title && (
      <div>
        <p className="text-xs font-bold uppercase tracking-[0.2em] text-[#C2410C]">Sehatic-Pedia</p>
        <h1 className="font-heading text-3xl sm:text-4xl font-black tracking-tight text-stone-900 mt-1" data-testid="page-title">{title}</h1>
        {subtitle && <p className="text-sm text-stone-600 mt-2">{subtitle}</p>}
      </div>
    )}
    {children && <div className="sm:ml-auto">{children}</div>}
  </div>
));
